import React, { useEffect, useState } from 'react';
import { Content } from 'antd/lib/layout/layout';
import { Alert, Steps, Grid } from 'antd';
import { Auth } from 'aws-amplify';
import { BulbTwoTone, UserOutlined } from '@ant-design/icons';
import { User } from '../../interfaces/api/Auth';
import Title from 'antd/lib/typography/Title';
import { StepProps } from 'antd/lib';
import { UserQuestionsStep } from './steps';
import { useHistory, useParams } from 'react-router-dom';
import ProjectQuestionStep from './steps/ProjectQuestionStep';

const { useBreakpoint } = Grid;

const OnboardingContainer: React.FC = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [user, setUser] = useState<User>();
  const { accountId } = useParams<{ accountId: string }>();
  const history = useHistory();

  useEffect(() => {
    Auth.currentAuthenticatedUser().then((user) => {
      setUser(user);
    });
  }, [accountId]);

  const breakpoint = useBreakpoint();
  const isMobile = !breakpoint.lg && !breakpoint.xl && !breakpoint.xxl;

  const goNextStep = () => {
    const nextStep = currentStep + 1;

    localStorage.setItem('onboardingStep', nextStep.toString());
    setCurrentStep(nextStep);
  };

  const goPrevStep = () => {
    const prevStep = currentStep - 1;
    localStorage.setItem('onboardingStep', prevStep.toString());
    setCurrentStep(prevStep);
  };

  const stepItems: StepProps[] = [
    {
      icon: <UserOutlined />,
      title: 'Please Tell Us About Yourself',
      description: (
        <UserQuestionsStep next={goNextStep} prev={goPrevStep} user={user} />
      )
    },
    {
      icon: <BulbTwoTone />,
      title: 'What do you need notifications for?',
      description: (
        <ProjectQuestionStep
          next={() => {
            return Auth.updateUserAttributes(user, {
              'custom:signUpCompleted': 'true'
            }).then(() => {
              history.push(`/${accountId}/notifications`);
            });
          }}
          prev={goPrevStep}
        />
      )
    }
  ];

  return (
    <Content style={{ padding: '20px' }}>
      {isMobile && (
        <Alert
          type="warning"
          message="Hello there! It looks like you may be on a mobile device. To get the most out of your experience, it is recommended to use NotificationAPI on a desktop instead."
          closable
          showIcon
          style={{ marginBottom: '20px' }}
        />
      )}
      <Steps
        current={currentStep}
        labelPlacement="horizontal"
        direction="vertical"
      >
        {stepItems.map((step, i) => {
          return (
            <Steps.Step
              key={`step_${i}`}
              icon={step.icon}
              title={
                <Title
                  level={4}
                  type={currentStep === i ? undefined : 'secondary'}
                  style={{
                    textDecoration: currentStep <= i ? '' : 'line-through',
                    margin: 0,
                    fontSize: '1.5rem',
                    lineHeight: '1.2'
                  }}
                >
                  {i + 1}. {step.title}
                </Title>
              }
              description={currentStep === i && step.description}
            />
          );
        })}
      </Steps>
    </Content>
  );
};

export default OnboardingContainer;
